import { Box, Button, FormControl, FormLabel, Grid, IconButton, InputAdornment, TextField } from "@material-ui/core";
import { useFormik } from "formik";
import * as yup from "yup";
import React, { useState, useCallback } from "react";
import { Visibility, VisibilityOff, Refresh } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { toImageUrl } from "../../../../../utils/formatHelper";
import UploadfileImage from "../../../../components/UploadfileImage";

function FormUserMobile({
    onClose = () => {},
    onResetPin = () => {},
    onSubmit = () => {},
    isCreateMode = false,
    initailUserFormValues = {},
}) {
    const [handleShowPass, setHandleShowPass] = useState(false);
    const [handleSelect, setHandleSelect] = useState("");
    const [fileImage, setFileImage] = useState(
        initailUserFormValues?.imagePath
            ? [
                  {
                      id: 1,
                      name: initailUserFormValues?.imagePath,
                      src: toImageUrl(initailUserFormValues?.imagePath),
                  },
              ]
            : [],
    );

    // validation
    const validationSchema = yup.object({
        hnNumber: yup
            .string()
            .min(6, "Please enter a minimum of 6 characters.")
            .required("Required"),
        fullname: yup.string().required("Required"),
        phoneNumber: yup
            .string()
            .matches(/^\d+$/, "The field should have number only.")
            .required("Required"),
        email: yup.string().email("Valid email format is example@mail.com"),
        username: yup
            .string()
            .max(50, "Username should not be too long.")
            .required("Required"),
        password: isCreateMode
            ? yup
                  .string()
                  .min(8, "Please enter a minimum of 8 characters.")
                  .required("Required")
            : null,
        images: yup.array(),
    });

    // config form
    const formik = useFormik({
        initialValues: initailUserFormValues,
        validationSchema: validationSchema,
        onSubmit: values => {
            onSubmit(values);
        },
    });

    const uploadImageFile = useCallback(
        file => {
            const reader = new FileReader();
            reader.readAsDataURL(file[0]);
            reader.onload = async evt => {
                setFileImage([{ id: 1, name: file[0].name, src: evt.target?.result }]);
            };
            formik.handleChange({
                target: {
                    type: "change",
                    id: "images",
                    name: "images",
                    value: [{ id: 1, name: file[0].name, src: file[0] }],
                },
            });
        },
        [setFileImage, formik],
    );

    const removeFile = file => {
        setFileImage(prev => (prev[0]?.id === file[0]?.id ? [] : prev));
    };

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={3}>
                {/* Upload image */}
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={7}>
                            <UploadfileImage
                                emptyImg={toAbsoluteUrl("/media/HCH/users/empty_img.png")}
                                onAcceptedFiles={uploadImageFile}
                                previewImages={fileImage}
                                removeButton={false}
                                removeAll={removeFile}
                                classPreview="col-6"
                                classActions="col-6"
                                hiddenButton={true}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                {/* ID HN */}
                <Grid item xs={12} md={6} className="mr-0 mr-lg-5">
                    <FormControl className="t-form-group-custom" fullWidth>
                        <FormLabel className="text-dark mb-4">HN</FormLabel>
                        <TextField
                            fullWidth
                            type="text"
                            name="hnNumber"
                            variant="outlined"
                            size="small"
                            value={formik.values.hnNumber}
                            onChange={formik.handleChange}
                            error={formik.touched.hnNumber && Boolean(formik.errors.hnNumber)}
                            helperText={formik.touched.hnNumber && formik.errors.hnNumber}
                            disabled
                        />
                    </FormControl>
                </Grid>
                {/* Name and lastname */}
                <Grid item xs={12} md={6}>
                    <FormControl className="t-form-group-custom" fullWidth>
                        <FormLabel className="text-dark mb-4">Fullname</FormLabel>
                        <TextField
                            fullWidth
                            type="text"
                            name="fullname"
                            variant="outlined"
                            size="small"
                            value={formik.values.fullname}
                            onChange={formik.handleChange}
                            error={formik.touched.fullname && Boolean(formik.errors.fullname)}
                            helperText={formik.touched.fullname && formik.errors.fullname}
                            disabled
                        />
                    </FormControl>
                </Grid>

                {/* Access rights */}
                <Grid item xs={12} md={6}>
                    <FormControl className="t-form-group-custom" fullWidth>
                        <FormLabel className="text-dark mb-4">Access right</FormLabel>
                        <Autocomplete
                            disabled
                            size="small"
                            value={handleSelect || formik.values?.patientPlanObj}
                            onChange={(event, value) => {
                                // custom for formik validate
                                const e = {
                                    persist: () => {},
                                    target: {
                                        type: "change",
                                        id: "patientPlan",
                                        name: "patientPlan",
                                        value: value ? value?.value : "",
                                    },
                                };
                                formik.handleChange(e);
                                setHandleSelect(value);
                            }}
                            options={[
                                { value: "สิทธิประกันสังคม", label: "สิทธิประกันสังคม" },
                                { value: "สิทธิทั่วไป", label: "สิทธิทั่วไป" },
                            ]} // *** data = [] option
                            getOptionLabel={option => option?.label || ""}
                            renderInput={params => (
                                <TextField
                                    {...params}
                                    label="Cloose"
                                    variant="outlined"
                                    name="patientPlan"
                                    value={formik.values?.patientPlan}
                                    error={formik.touched?.patientPlan && Boolean(formik.errors?.patientPlan)}
                                    helperText={formik.touched?.patientPlan && formik.errors?.patientPlan}
                                />
                            )}
                        />
                    </FormControl>
                </Grid>

                {/* Phone */}
                <Grid item xs={12} md={6}>
                    <FormControl className="t-form-group-custom" fullWidth>
                        <FormLabel className="text-dark mb-4">Phone</FormLabel>
                        <TextField
                            fullWidth
                            type="tel"
                            name="phoneNumber"
                            variant="outlined"
                            size="small"
                            value={formik.values.phoneNumber}
                            onChange={formik.handleChange}
                            error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                            helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
                            disabled
                        />
                    </FormControl>
                </Grid>

                {/* email */}
                <Grid item xs={12} md={6}>
                    <FormControl className="t-form-group-custom" fullWidth>
                        <FormLabel className="text-dark mb-4">Email</FormLabel>
                        <TextField
                            fullWidth
                            type="email"
                            name="email"
                            variant="outlined"
                            size="small"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                            disabled
                        />
                    </FormControl>
                </Grid>

                {/* username */}
                <Grid item xs={12} md={6}>
                    <FormControl className="t-form-group-custom" fullWidth>
                        <FormLabel className="text-dark mb-4">Username</FormLabel>
                        <TextField
                            fullWidth
                            type="text"
                            name="username"
                            variant="outlined"
                            size="small"
                            value={formik.values.username}
                            onChange={formik.handleChange}
                            error={formik.touched.username && Boolean(formik.errors.username)}
                            helperText={formik.touched.username && formik.errors.username}
                            disabled
                        />
                    </FormControl>
                </Grid>

                {/* password */}
                <Grid item xs={12} md={6}>
                    <FormControl className="t-form-group-custom" fullWidth>
                        <FormLabel className="text-dark mb-4">Password</FormLabel>
                        <TextField
                            fullWidth
                            type={handleShowPass ? "text" : "password"}
                            name="password"
                            variant="outlined"
                            size="small"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            error={formik.touched.password && Boolean(formik.errors.password)}
                            helperText={formik.touched.password && formik.errors.password}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setHandleShowPass(!handleShowPass)}>
                                            {handleShowPass ? (
                                                <VisibilityOff style={{ color: "#808080" }} />
                                            ) : (
                                                <Visibility style={{ color: "#808080" }} />
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </FormControl>
                </Grid>

                {/* reset pin */}
                <Grid item xs={12}>
                    <Box className="row justify-content-lg-start">
                        <div className="col-6 col-lg-3 ">
                            <Button
                                onClick={() => onResetPin(formik.values.usersMobileId)}
                                className="w-100 btn t-btn-secondary">
                                <i className="mr-1" style={{ color: "inherit" }}></i>
                                <Refresh /> Reset PIN
                            </Button>
                        </div>
                    </Box>
                </Grid>

                {/* actions */}
                <Grid item xs={12}>
                    <Box className="row justify-content-lg-end">
                        <div className="col-6 col-lg-3 ">
                            <Button type="submit" className="w-100 btn t-btn-primary">
                                <i className="fas fa-save mr-1" style={{ color: "inherit" }}></i>
                                {isCreateMode ? "Create" : "Update"}
                            </Button>
                        </div>
                        <div className="col-6 col-lg-3 ">
                            <Button type="button" onClick={() => onClose(false)} className="w-100 btn t-btn-gray">
                                cancel
                            </Button>
                        </div>
                    </Box>
                </Grid>
            </Grid>
        </form>
    );
}

export default FormUserMobile;
